export default __webpack_public_path__ + "static/ACP-JCA-05ca9aaf647ffcfd7513856dfaec2ef8.png";